import React, { useState } from 'react'
import DataTable from "../../../components/Website/DataTable"

function WishList() {
    const [columns] = useState([
        {
          header: "Item",
          accessorKey: "order_id",
        },
        {
          header: "Price",
          accessorKey: "date",
        },
        {
          header: "Actions",
          accessorKey: "total",
        },
      ])
    const [data] = useState([])
  return (
    <div className='w-full p-4'>
        <h2 className='text-4xl font-semibold'>Wish List</h2>
        <DataTable columns={columns} data={data} footer={false} />
    </div>
  )
}

export default WishList